import { cn, shouldShowSignUp } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { IoIosMenu } from 'react-icons/io';
import { IoIosClose } from 'react-icons/io';
import { Button } from '../button';
import { Logo } from '../Logo';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { LanguageSelector } from './LanguageSelector';
import { useTranslation } from 'react-i18next';

export const MobileNavbar = ({
  navItems,
  landingMode = false,
}: {
  navItems: any[];
  landingMode?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('common');

  // Use window-level scroll with proper options
  const { scrollY } = useScroll({
    layoutEffect: false, // Must be false to prevent hydration issues
    container: false, // Use the viewport as a container
  });

  const [showBackground, setShowBackground] = useState(false);
  const showSignUp = shouldShowSignUp();

  useMotionValueEvent(scrollY, 'change', value => {
    if (value > 100) {
      setShowBackground(true);
    } else {
      setShowBackground(false);
    }
  });

  return (
    <div
      className={cn(
        'flex justify-between bg-white dark:bg-neutral-900 items-center w-full rounded-full px-2.5 py-1.5 transition duration-200',
        showBackground &&
          'bg-neutral-50 dark:bg-neutral-900 shadow-[0px_-2px_0px_0px_var(--neutral-100),0px_2px_0px_0px_var(--neutral-100)] dark:shadow-[0px_-2px_0px_0px_var(--neutral-800),0px_2px_0px_0px_var(--neutral-800)]'
      )}
    >
      <Logo />
      <IoIosMenu className="text-black dark:text-white h-6 w-6" onClick={() => setOpen(!open)} />
      {open && (
        <div className="fixed inset-0 bg-white dark:bg-black z-50 flex flex-col items-start justify-start space-y-10  pt-5  text-xl text-zinc-600  transition duration-200 hover:text-zinc-800">
          <div className="flex items-center justify-between w-full px-5">
            <Logo />
            <div className="flex items-center space-x-2">
              <LanguageSelector />
              <IoIosClose
                className="h-8 w-8 text-black dark:text-white"
                onClick={() => setOpen(!open)}
              />
            </div>
          </div>
          <div className="flex flex-col items-start justify-start gap-[14px] px-8">
            {navItems.map((navItem: any, idx: number) => (
              <>
                {navItem.children && navItem.children.length > 0 ? (
                  <>
                    {navItem.children.map((childNavItem: any, idx: number) => (
                      <Link
                        key={`link=${idx}`}
                        to={childNavItem.link}
                        onClick={() => setOpen(false)}
                        className="relative max-w-[15rem] text-left text-2xl"
                      >
                        <span className="block text-black">{childNavItem.title}</span>
                      </Link>
                    ))}
                  </>
                ) : (
                  <Link
                    key={`link=${idx}`}
                    to={navItem.link}
                    onClick={() => setOpen(false)}
                    className="relative"
                  >
                    <span className="block text-[26px] text-black dark:text-white">
                      {navItem.title}
                    </span>
                  </Link>
                )}
              </>
            ))}
          </div>
          {!landingMode && (
            <div className="flex flex-row w-full items-start gap-2.5 px-8 py-4">
              {showSignUp && <Button to="/signup">{t('nav.signup')}</Button>}
              <Button variant="simple" href="https://app2.verdea.app/">
                {t('nav.login')}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
